<template>
  <div class="home-page" style="height:100vh;padding:0">
    <!-- <div class="nav flex">
    	<div class="back" @click="back">
    		<img src="static/images/return.png" />
    	</div>
    	<span class="">Games</span>
    </div> -->
    <iframe class="iframe" :src="gameUrl"></iframe>
    <floatBtn/>
    <Dialog ref="saveDialog" type="alert" :callback="saveModal" title="Reminder" :btnText="$t('OK')" :cancelText="$t('OK')">
        <div slot="mdBox" >
            <div class="mt100">{{msg}}</div>
        </div>
    </Dialog>
	</div>
</template>
<script>
import Header from '../components/header'
import floatBtn from '../components/floatBtn';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,floatBtn,
    Dialog
    },
    data() {
      return {
        gameUrl:'',
        msg:'',
      }
    },
	created(){
		this.getHome();
    //$t('FAQs')
    //this.gameUrl = this.$route.query.game_id
	},
    methods: {
		back(){
      console.log(this.$route.query.keywords)
      if(this.$route.query.keywords) {
        console.log(this.$route.query.keywords)
        this.$router.push({path:'/searchList',query:{keywords:this.$route.query.keywords}});
      }else{
        this.$router.go(-1);
      }
		},
    getHome(){
      let that = this
      let data = {
        game_id:this.$route.query.game_id
      }
      that.$parent.loadModal(true);
      that.$api.get('/api/game/go',data,r =>{
        //that.$parent.returnCode(r,function(){
          console.log(r.code)
          that.$parent.loadModal(false);
          if(r.code==1){
            that.gameUrl = r.data.url
          }else{
            console.log(r)
            that.$refs.saveDialog.showMaskFun();
            that.msg = r.msg
          }

        //})
      })
    },
    saveModal(){
      localStorage.removeItem('token')
      this.$router.push({path:'/land'});
    },
	}
}
</script>
<style>
  .iframe{width:100%;height: 100%;border:none}
</style>



// WEBPACK FOOTER //
// src/page/game.vue